import { render, staticRenderFns } from "./AjustesOrigen.vue?vue&type=template&id=44552211&scoped=true"
import script from "./AjustesOrigen.vue?vue&type=script&lang=js"
export * from "./AjustesOrigen.vue?vue&type=script&lang=js"
import style0 from "./AjustesOrigen.vue?vue&type=style&index=0&id=44552211&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44552211",
  null
  
)

export default component.exports